import { observer } from 'mobx-react-lite';

import {
  type BaseModalFCProps,
  type ModalFC,
} from '@/components/modals/modalsManager';
import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/dialog';
import { XStack, YStack } from '@/components/ui/layout/layout';
import { Switch } from '@/components/ui/Switch';

type CustomizeSidebarModalProps = BaseModalFCProps & {
  items: { id: string; label: string; icon: React.ReactNode }[];
  isShown: (id: string) => boolean;
  onToggle: (id: string) => void;
};

export const CustomizeSidebarModal: ModalFC<CustomizeSidebarModalProps> =
  observer(({ items, isShown, onToggle, open, onOpenChange }) => (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content showCloseButton className="max-w-sm">
        <YStack className="gap-5">
          <YStack className="gap-1">
            <Dialog.Title className="text-lg font-medium text-foreground">
              Customize sidebar
            </Dialog.Title>
            <Dialog.Description className="text-sm text-foreground-muted">
              Pick what shows in the sidebar. The rest stays under More.
            </Dialog.Description>
          </YStack>
          <YStack className="gap-0.5">
            {items.map((item) => (
              <label
                key={item.id}
                className="flex items-center gap-3 rounded-lg px-2.5 py-2 hover:bg-surface-hover"
              >
                <span className="flex size-6 shrink-0 items-center justify-center text-foreground-muted [&>svg]:size-4">
                  {item.icon}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground">
                  {item.label}
                </span>
                <Switch
                  checked={isShown(item.id)}
                  onCheckedChange={() => onToggle(item.id)}
                />
              </label>
            ))}
          </YStack>
          <XStack className="justify-end">
            <Button variant="default" onClick={() => onOpenChange(false)}>
              Done
            </Button>
          </XStack>
        </YStack>
      </Dialog.Content>
    </Dialog.Root>
  ));
